
export function unixTimeToString(unixTime)
{
	var date = new Date(unixTime);

	var curr_month = date.getMonth() + 1; //Months are zero based
	var curr_year = date.getFullYear();
	var day = date.getDate();

	return curr_year + "/" + curr_month + "/" + day;
}

export function randomFloat(minim,maxim)
{
	let val = Math.random();
	let range = maxim - minim;
	val *= range;
	return val + minim;
}

export function randomInteger(min, max) 
{
  return Math.floor(Math.random() * (max - min + 1) ) + min;
}